module.exports = __webpack_public_path__ + "img/5.fad89a31.png";